"use strict";

exports.__esModule = true;
exports.SubscribeClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _constants = require("../constants");
const SubscribeClient = {
  /**
   *
   * @param {string} uname
   * @param {string} email
   *
   * @returns {Promise}
   *
   * @description subscribe the user for notifications
   */
  subscribe({
    name,
    email
  }) {
    const requestId = 'SUBSCRIBE';
    const endPoint = _constants.ENDPOINTS.SUBSCRIBE;
    return _http.$http.post(requestId, endPoint, {
      data: {
        name,
        email
      }
    }).then(({
      data
    }) => data);
  }
};
exports.SubscribeClient = SubscribeClient;